import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { DetailAccountModel, DetailRevolvingCreditModel } from 'src/app/shared/models/abre-cuentas.model';
import { ClientProductModel } from 'src/app/shared/models/client-products.model';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { SignOnService } from 'src/app/shared/services/sign-on/sign-on.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';

import { RISK_LEVELS } from '../../../shared/constants/rate.constants';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import {
  ChannelCommunicatorService,
} from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductLoaderService } from '../../../shared/services/product-loader/product-loader.service';
import { RequestService } from '../../../shared/services/request/request-onboarding.service';
import { AccountCreationStatus } from '../detail-account-creation/detail-account-creation.component';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustCA, callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { OFFERS_STATUS_CONST } from 'src/app/shared/constants/offers-status.constants';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  PAGEVIEW as PAGEVIEW_FA_LD,
  CHANNEL as CHANNEL_FA_LD,
  COUNTRY as COUNTRY_FA_LD,
  BUSINNESS as BUSINNESS_FA_LD,
  ENVIRONMENT as ENVIRONMENT_FA_LD,
  FAMILY as FAMILY_FA_LD,
  SUBFAMILY as SUBFAMILY_FA_LD,
  PRODUCT as PRODUCT_FA_LD,
} from 'src/app/shared/constants/dali-fa-ld.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-account-info-creation',
  templateUrl: './account-info-creation.component.html',
  styleUrls: ['./account-info-creation.component.scss'],
})
export class AccountInfoCreationComponent implements OnInit {
  acceptTerms = false;
  showCharacteristics: boolean;
  disbursment: any;
  modalShow: boolean;
  pco: any;
  userId: any;
  formGroup: FormGroup;
  product: any;
  taxRates: any;
  showRate = false;
  transaction: any;
  infoInferredIncomes: any;
  solicitationId: any;
  check: any;
  revolvingBenefits: any;
  amountPco: any;
  maxPeriodTerm: any;
  transactionkit: any;
  termsConditions: any;
  terms: any;
  acctStatus: AccountCreationStatus;
  acctProcessId: string;
  detailAccountInfo: DetailAccountModel;
  detailRevolvingCredit: DetailRevolvingCreditModel;
  termValue: any; fg;
  readonly RISK_LEVELS = RISK_LEVELS;
  productClient: boolean;
  selectedAccount: ClientProductModel;
  accountNumber: any;
  rateLiving: any;
  rateLib: any;
  continueRelated: boolean;
  firmlyApproved: boolean;
  loanDescriptionCheck: any;

  @Output() continueClick = new EventEmitter();
  @Output() callLink = new EventEmitter();
  grayZone: boolean;

  constructor(
    private headerService: HeaderService,
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private numberHelper: FormatNumberService,
    private navigationService: NavigationService,
    private productLoaderService: ProductLoaderService,
    private bioCatchService: BioCatchService,
    private signOnService: SignOnService,
    private parametersService: ParametersService,
    private bitacoraService: BitacoraService,
    private requestService: RequestService,
    public loader: LoaderService,
    private validationHelperService: ValidationHelperService,
    private helperService: HelpersService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private postValidate: PostValidateService,
    private captureService: CaptureService,
    private firmlyApprovedService: FirmlyApprovedService,
    private identificationService: IdentificationService,
    private adjustEvent: AdjustEvent,
    private daliService: DaliService,
    private taggingService: TaggingService,
  ) {
    this.modalShow = false;
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    this.sendTagging('init');
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendAccountInfoCreationLoad();
    }
    this.firmlyApproved = !this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme';
    this.disbursment = this.abreCuentasService.getDisbursementInfo();
    console.log('Metodo Desembolso: ', this.disbursment);
    this.abreCuentasService.getDocumentInfo();
    this.formGroup = new FormGroup({
      check_terms: new FormControl('', [Validators.required]),
    });
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    const isEvidente = this.bioCatchService.isEvidenteCase();
    this.bioCatchService.changeContext(StepBiocatchEnum.vinculacion, product, false, isEvidente);
    if (!this.firmlyApproved) {
      this.pco = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
      console.log('AAAaaProducto:' + this.pco);
    } else {
      this.requestService.setRates(this.abreCuentasService.getAbreCuentasModel().creditParms.rateValue);
    }
    this.product = this.abreCuentasService.getproductSelected().code;
    this.productClient = this.abreCuentasService.getClientProduct();
    console.log('AAAaaClient:' + this.productClient);
    this.selectedAccount = this.abreCuentasService.getcreateProductSelected();
    this.transaction = this.parametersService.getSetting(OpEnum.TRANSACTION_KIT);
    this.infoInferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
    this.userId = this.abreCuentasService.getDocumentInfo();
    this.solicitationId = this.abreCuentasService.getSolicitationId();
    switch (this.product) {
      case '209':
        this.revolvingBenefits = this.parametersService.getSetting(OpEnum.REVOLVING_BENEFITS);
        if (!this.selectedAccount) {
          this.selectedAccount = this.abreCuentasService.getAssociateRevolving();
        }
        if (this.firmlyApproved) {
          this.amountPco = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)[0].limit_amount.amount.toString();
        } else {
          this.amountPco = this.pco === 'PCO03' ?
            '' :
            this.abreCuentasService.getAmountPcoAproved() + '';
        }
        this.amountPco = this.amountPco !== '' ? this.numberHelper.pcoFormat(this.amountPco) : '';
        this.termValue = this.copyService.copies.account_info_creation.term_value;
        if (this.productClient && this.selectedAccount && this.selectedAccount.account_id) {
          this.accountNumber = this.validationHelperService.maskPhone(this.selectedAccount.account_id);
        } else {
          this.accountNumber = '';
        }
        // this.accountNumber = this.productClient ? this.validationHelperService.maskPhone(this.selectedAccount.account_id) : '';
        break;
      case '211':
      case '231':
        const creditParams = this.abreCuentasService.getAbreCuentasModel().creditParms;
        this.amountPco = this.firmlyApproved ?
          this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue.toString() :
          this.pco === 'PCO03' ?
            this.numberHelper.amountFormat(creditParams.maxAmountValue) :
            this.abreCuentasService.getAmountPcoAproved() + '';
        console.log('Valor a formatear: ', this.amountPco);
        this.amountPco = this.numberHelper.pcoFormat(this.amountPco);
        this.maxPeriodTerm = creditParams.maxPeriodValue;
        this.termValue = `${this.maxPeriodTerm} meses`;
        this.accountNumber = this.productClient ? this.validationHelperService.maskPhone(this.selectedAccount.account_id) : '';
        console.log('Rates: ', this.requestService.getRates());
        const rates = this.requestService.getRates();
        this.rateLiving = this.firmlyApproved ?
          `${rates.rate_MV}% M.V  (${rates.rate_EA}% E.A)` :
          `${rates[0].value}% ${rates[0].type}  (${rates[1].value}% ${rates[1].type})`;
        this.getRates();
        break;
      case '999':
        this.check = this.abreCuentasService.getOutlaySelection() === 'cheque';
        const incomes = this.abreCuentasService.getFinancialInfo();
        const creditParamsLib = this.abreCuentasService.getAbreCuentasModel().creditParms;
        this.amountPco = this.pco === 'PCO03' ?
          this.numberHelper.amountFormat(creditParamsLib.maxAmountValue) :
          this.abreCuentasService.getAmountPcoAproved() + '';
        this.amountPco = this.numberHelper.pcoFormat(this.amountPco);
        this.maxPeriodTerm = creditParamsLib.maxPeriodValue;
        this.termValue = `${this.maxPeriodTerm} meses`;
        if (this.disbursment && this.disbursment[0]) {
          const refund = this.disbursment[0].refund;
          if (refund && refund[0] && refund[0].refund_method !== 'CH') {
            this.accountNumber = refund[0].account ? this.validationHelperService.maskPhone(refund[0].account.account_id) : '';
          }
        } else {
          this.accountNumber = this.productClient ? this.validationHelperService.maskPhone(this.selectedAccount.account_id) : '';
        }
        this.showCharacteristics = incomes.incomes <= 7999000 ? false : true;
        this.showRate = true;
        this.rateLib = this.abreCuentasService.getRatesLoan();
        break;
      case '232':
        const creditParamLib = this.abreCuentasService.getAbreCuentasModel().creditParms;
        this.amountPco = this.pco === 'PCO03' ?
          this.numberHelper.amountFormat(creditParamLib.maxAmountValue) :
          this.abreCuentasService.getAmountPcoAproved() + '';
        this.amountPco = this.numberHelper.pcoFormat(this.amountPco);
        this.maxPeriodTerm = creditParamLib.maxPeriodValue;
        this.termValue = `${this.maxPeriodTerm} meses`;
        if (this.disbursment && this.disbursment[0]) {
          const refund = this.disbursment[0].refund;
          if (refund && refund[0] && refund[0].refund_method !== 'CH') {
            this.accountNumber = refund[0].account ? this.validationHelperService.maskPhone(refund[0].account.account_id) : '';
          }
        } else {
          this.accountNumber = this.productClient ? this.validationHelperService.maskPhone(this.selectedAccount.account_id) : '';
        }
        this.showRate = true;
        this.rateLib = this.abreCuentasService.getRatesLoan();
        break;
      default:
        break;
    }
    /* if (this.abreCuentasService.getProspectResponse().client &&
      (this.abreCuentasService.getCustomerData().basic.sub_segment_id === '335' ||
        this.abreCuentasService.getCustomerData().basic.sub_segment_id === '315')) {
      this.infoInferredIncomes.segment_id =
        parseInt(this.abreCuentasService.getCustomerData().basic.sub_segment_id, 10);
    } */
    this.transactionkit = this.transaction.filter(transaction =>
    (transaction.account_type === this.infoInferredIncomes.account_type &&
      transaction.segmentation_id === this.infoInferredIncomes.segment_id));
    this.transactionkit = this.transactionkit[0];
    const listTermsConditions = this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS);
    this.termsConditions = listTermsConditions[2];

    this.terms = {
      description: this.termsConditions.description,
      title: this.termsConditions.code,
      terms_id: this.termsConditions.id,
    };
  }

  monthly(months: number) {
    return `${months} ${this.copyService.copies.account_info_creation.monthly}`;
  }

  getRates() {
    this.taxRates = this.requestService.getRates();
    this.showRate = true;
  }

  checkTerms(event: any) {
    this.acceptTerms = event.checked;
  }

  showModalEvent(event) {
    switch (event.type) {
      case 'primary':
        this.downloadPdf();
        break;
      case 'click':
        this.modalShow = true;
        break;
      case 'close':
        this.modalShow = false;
        break;
      default:
        break;
    }
  }

  /**
   * Method to download pdf
   */
  downloadPdf() {
    this.channelCommunicatorService.getImpl().openPdf(
      this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)[0].pdfUrl);
  }

  /*   openLink() {
      this.callLink.emit();
    } */

  async checkBioCatch() {
    this.sendTagging('next', 'center', '2');
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendRequestButtonEvent();
    }
    await this.bioCatchService.update();
    this.bioCatchService.checkScore(false).then(response => {
      if (response.data.response) {
        this.next();
        return;
      }
      this.navigationService.navigateToGeneralInformation('122');
      this.navigationService.pageLoadTag('Error carga vinculacion', ['', 'pv132', 'pv93']);
      const productSelected = this.abreCuentasService.getproductSelected();
      if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
        const event = {
          eventToken: 'n2wxne',
          callbackParams: callbackAdjustCA,
        };
        this.adjustEvent.adjustTrackEvent(event);
      } else if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        const event = {
          eventToken: '6hsnuc',
          callbackParams: callbackAdjustContratarTC,
        };
        this.adjustEvent.adjustTrackEvent(event);
      }
    }, () => {
      this.navigationService.navigateToGeneralInformation('500');
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  async next() {
    this.loader.show('Alta_Productos_zn');
    const product_name = this.abreCuentasService.getproductSelected().product_code;
    if (this.abreCuentasService.haveLoan) {
      this.productLoaderService.show(this.copyService.copies.show_load_pco,
        this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']);
    }
    const gray_zone = this.pco === 'PCO03' ? 'zg_' : '';
    this.grayZone = this.pco === 'PCO03' ? true : false;
    let bitacoraEvent = '';
    if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
      const productType = {
        ORD: 'cp',
        TCR: 'tc',
        CRP: 'cr',
        default: '',
      };
      this.bitacoraService.saveDataInBitacora(`offer_approvedf_${product_name}`);
      bitacoraEvent = `af_accepted_multi_${productType[product_name] ? productType[product_name] : productType.default}`;
    } else {
      bitacoraEvent = `product_accepted_${gray_zone}${product_name}`;
    }
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    // Relacionados
    await this.checkRelated();
    if (!this.continueRelated) {
      this.productLoaderService.hide();
      return;
    }
    this.signOnService.termsAndConditions();
    try {
      await this.postValidate.performSolicitation();
      this.bitacoraService.saveDataInBitacora('Ini_loading_Product');
      await this.callerSleep();
      await this.captureService.getChannelComunicator(true).then((res2: any) => {
        if (CHANNEL.PORTALO.CODE === this.abreCuentasService.chanelid && this.abreCuentasService.getflagGreyZone()) {
          this.loader.hide('Alta_Productos_zn');
          this.navigationService.navigateToGeneralInformation('137');
          return;
        } else if (!this.grayZone && (this.abreCuentasService.getproductSelected().product_type === 'freeInvestment' ||
          this.abreCuentasService.getproductSelected().product_type === 'revolvingCredit' ||
          this.abreCuentasService.getproductSelected().product_type === 'loan')) {
          if (!this.firmlyApprovedService.isEmpty()) {
            let product_list: any = [];
            product_list.push(this.abreCuentasService.getproductSelected());
            this.firmlyApprovedService.turnOffOffer(
              OFFERS_STATUS_CONST.PRODUCT_ACCEPTED.CODE,
              product_list);
          }
          this.bitacoraService.saveDataInBitacora('Out_loading_Product');
          this.loader.hide('Alta_Productos_zn');
          this.navigationService.navigateToGeneralInformation('138');
          return;
        } else {
          (res2 === '107' || res2 === '121' || res2 === '130' || res2 === '129' || res2 === '124' || res2 === '125' || res2 === '127') ?
            this.navigationService.navigateToGeneralInformation(res2) :
            this.navigationService.nextStep(res2);
        }
        if (res2 === '208') {
          this.bitacoraService.saveDataInBitacora('Possible_fraud_Yes');
        } else if (res2 === '20-04') {
          res2 = '208';
          this.bitacoraService.saveDataInBitacora('Possible_fraud_incident');
        }
        const productSelected = this.abreCuentasService.getproductSelected();
        if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && res2 === '121') {
          const event = {
            eventToken: 'huswfn',
            callbackParams: callbackAdjustContratarTC,
          };
          this.adjustEvent.adjustTrackEvent(event);
        }
        this.bitacoraService.saveDataInBitacora('Out_loading_Product');
        this.loader.hide('Alta_Productos_zn');
        this.productLoaderService.hide();
      }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
    } catch (error) {
      this.loader.hide('Alta_Productos_zn');
      console.log(error);
      this.navigationService.navigateToGeneralInformation('107');
    }
  }

  async callerSleep() {
    this.abreCuentasService.haveLoan ? await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']) :
      await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.BONDING_ASYNC)['sleep']);
  }

  async checkRelated() {
    this.continueRelated = true;
    let document = this.abreCuentasService.getDocumentInfo().document_number;
    const resInfo = await this.identificationService.validateIfIsRelated(document);
    console.log(resInfo);
    if (!resInfo.related) { return; }
    // BITÁCORA CON employee_members
    const bitacoraEvent = `employee_members`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);

    // Verificar estado PCO
    let pcoStatus = this.abreCuentasService.getPcoModel().solicitation_status.status_code;

    // PCO Aprobado continúa a "Tu solicitud fue recibida y la estamos validando"
    if (pcoStatus !== 'PCO01') { return; }
    this.navigationService.nextStep('202');
    this.productLoaderService.hide();
    this.continueRelated = false;
  }
  goToLink() {
    this.channelCommunicatorService.getImpl()
      .openExternalBrowser('https://www.itau.co/tasasytarifas', 5, this.abreCuentasService.getPostlogin());
  }

  /* ------------------ Taggeo ------------------ */

  /* ------------ Taggeo - PageLoad ------------ */
  sendAccountInfoCreationLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA_LD.pv14pageName.path,
        value: `${isApp ? CHANNEL_FA_LD.superapp : CHANNEL_FA_LD.homeBanking}:${COUNTRY_FA_LD.co}:${BUSINNESS_FA_LD.pf}:${ENVIRONMENT_FA_LD.loggeado}:${FAMILY_FA_LD.services}:${SUBFAMILY_FA_LD.request}:${PRODUCT_FA_LD.request}:${PAGEVIEW_FA_LD.pv14pageName.value}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv14pageFamily.path,
        value: PAGEVIEW_FA_LD.pv14pageFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv14subFamily.path,
        value: PAGEVIEW_FA_LD.pv14subFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv14pageAction.path,
        value: PAGEVIEW_FA_LD.pv14pageAction.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv14pageid.path,
        value: AccountInfoCreationComponent.name,
      },
      {
        path: PAGEVIEW_FA_LD.pv14transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv14transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv14transactionTransactionStep.path,
        value: PAGEVIEW_FA_LD.pv14transactionTransactionStep.value,
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */

  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'center', '1');
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv14E1setData.pv14E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv14E1setData.pv14E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv14E1setData.pv14E1transactionName.path,
        value: `${EVENT_FA_LD.pv14E1setData.pv14E1transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv14E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendRequestButtonEvent(): void {
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv14E2setData.pv14E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv14E2setData.pv14E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv14E2setData.pv14E2transactionName.path,
        value: `${EVENT_FA_LD.pv14E2setData.pv14E2transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv14E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const grayZone = this.abreCuentasService.isGrayZone();
    const page = grayZone ? '21' : '20';
    const extras = {
      pageValue: 'AccountInfoCreation' + (grayZone ? 'GrayZone' : ''),
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
